import { Moment } from 'moment-mini'

export enum SerieProposalStatus {
  REQUESTED = 0,
  ACCEPTED = 1,
  COUNTER_PROPOSAL = 2,
  DECLINED = 3
}

export enum SerieProposalType {
  REPEATABLE_BOOKING = 0,
  CUSTOM_DATE = 1
}

export class SerieProposalDetails {
  bookDuringHoliday?: boolean
  repeatPattern?: number
  repeatableBookings: Array<{
    dayOfWeek?: number
    startTime?: string
    endTime?: string
  }>
  customBookings: Array<{
    startDate: Date
    endDate: Date
  }>
  initialRequest: {
    productId: number
    linkedProductId: number
    locationId: number
    bookDuringHoliday?: boolean
    repeatPattern?: number
    repeatableBookings: Array<{
      dayOfWeek?: number
      startTime?: string
      endTime?: string
    }>
    customBookings: Array<{
      startDate: Date
      endDate: Date
    }>
  }
}

export class SerieProposal {
  id: number
  customerPersonId: number
  status: SerieProposalStatus
  organizationId: number
  internalMemo: string
  externalMemo: string
  createdAt: Moment
  updatedAt: Moment
  siteId?: number
  groupInformation: string
  startDate: Moment
  endDate: Moment
  details: SerieProposalDetails
  type: SerieProposalType
  linkedProductId: number
  productId: number
  // special
  hasConflict?: boolean
  // relations
  serieProposalItems: any[]
  messages: any[]

  dontSendMail?: boolean
}
